import { z } from "zod";

export const CodePostalEntrySchema = z.object({
  code: z.string(),
  ville: z.string(),
});

export const QuartierSchema = z.object({
  id: z.string(),
  nom: z.string().optional(),
  codesPostaux: z.array(CodePostalEntrySchema).optional(),
  descriptionFr: z.string().optional(),
  descriptionNl: z.string().optional(),
  descriptionEn: z.string().nullable().optional(),
  pointsInteretFr: z.string().optional(),
  pointsInteretNl: z.string().optional(),
  pointsInteretEn: z.string().nullable().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
});
export type QuartierRow = z.infer<typeof QuartierSchema>;

export const QuartierUpdateSchema = QuartierSchema
  .omit({ id: true, created_at: true, updated_at: true })
  .partial();
export type QuartierUpdate = z.infer<typeof QuartierUpdateSchema>;
